// JS
import {
  fetchProjectsFromBackend,
  fetchCategoriesFromBackend,
  fetchAllNewsFromBackend,
  fetchAllReviewsFromBackend,
  fetchAllExhibitionsFromBackend
} from '../../utils/rest'

function receiveProjectsError(error) {
  return {
    type: 'RECEIVE_PROJECTS_ERROR',
    error
  }
}

function receiveProjectsSuccess(projects) {
  return {
    type: 'RECEIVE_PROJECTS_SUCCESS',
    projects
  }
}

function requestProjects() {
  return {
    type: 'REQUEST_PROJECTS'
  }
}

/**
 * Fetch projects from backend and set them in redux store
 */
export function fetchProjects() {
  return async function (dispatch) {
    try {
      dispatch(requestProjects())

      const projectsList = await fetchProjectsFromBackend()

      dispatch(receiveProjectsSuccess(projectsList))
    }
    catch (err) {
      dispatch(receiveProjectsError(err))
    }
  }
}

function receiveCategoriesError(error) {
  return {
    type: 'RECEIVE_CATEGORIES_ERROR',
    error
  }
}

function receiveCategoriesSuccess(categories) {
  return {
    type: 'RECEIVE_CATEGORIES_SUCCESS',
    categories
  }
}

function requestCategories() {
  return {
    type: 'REQUEST_CATEGORIES'
  }
}

/**
 * Fetch categories from backend and set them in redux store
 */
export function fetchCategories() {
  return async function (dispatch) {
    try {
      dispatch(requestCategories())

      const categoriesList = await fetchCategoriesFromBackend()

      dispatch(receiveCategoriesSuccess(categoriesList.map(category => category.name)))
    }
    catch (err) {
      dispatch(receiveCategoriesError(err))
    }
  }
}

export function setCategory(category) {
  return {
    type: 'SET_CATEGORY',
    category
  }
}

function receiveNewsError(error) {
  return {
    type: 'RECEIVE_NEWS_ERROR',
    error
  }
}

function receiveNewsSuccess(news) {
  return {
    type: 'RECEIVE_NEWS_SUCCESS',
    news
  }
}

function requestNews() {
  return {
    type: 'REQUEST_NEWS'
  }
}

/**
 * Fetch news from backend and set them in redux store
 */
export function fetchNews() {
  return async function (dispatch) {
    try {
      dispatch(requestNews())

      const newsList = await fetchAllNewsFromBackend()

      dispatch(receiveNewsSuccess(newsList))
    }
    catch (err) {
      dispatch(receiveNewsError(err))
    }
  }
}

function receiveReviewsError(error) {
  return {
    type: 'RECEIVE_REVIEWS_ERROR',
    error
  }
}

function receiveReviewsSuccess(reviews) {
  return {
    type: 'RECEIVE_REVIEWS_SUCCESS',
    reviews
  }
}

function requestReviews() {
  return {
    type: 'REQUEST_REVIEWS'
  }
}

/**
 * Fetch reviews from backend and set them in redux store
 */
export function fetchReviews() {
  return async function (dispatch) {
    try {
      dispatch(requestReviews())

      const reviewsList = await fetchAllReviewsFromBackend()

      dispatch(receiveReviewsSuccess(reviewsList))
    }
    catch (err) {
      dispatch(receiveReviewsError(err))
    }
  }
}

function receiveExhibitionsError(error) {
  return {
    type: 'RECEIVE_EXHIBITIONS_ERROR',
    error
  }
}

function receiveExhibitionsSuccess(exhibitions) {
  return {
    type: 'RECEIVE_EXHIBITIONS_SUCCESS',
    exhibitions
  }
}

function requestExhibitions() {
  return {
    type: 'REQUEST_EXHIBITIONS'
  }
}

/**
 * Fetch exhibitions from backend and set them in redux store
 */
export function fetchExhibitions() {
  return async function (dispatch) {
    try {
      dispatch(requestExhibitions())

      const exhibitionsList = await fetchAllExhibitionsFromBackend()

      dispatch(receiveExhibitionsSuccess(exhibitionsList))
    }
    catch (err) {
      dispatch(receiveExhibitionsError(err))
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/app/actions.js